'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _loveButton = require('../loveButton.js');

var _loveButton2 = _interopRequireDefault(_loveButton);

var _fullscreenSocialDownload = require('../fullscreenSocialDownload.js');

var _fullscreenSocialDownload2 = _interopRequireDefault(_fullscreenSocialDownload);

var _fullscreenShareButtons = require('../fullscreenShareButtons.js');

var _fullscreenShareButtons2 = _interopRequireDefault(_fullscreenShareButtons);

var _utils = require('../../utils');

var _fullscreen = require('photography-client-lib/dist/src/versioning/features/fullscreen');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _itemActions = require('photography-client-lib/dist/src/item/itemActions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FullscreenMobileBarV1 = function (_React$Component) {
  (0, _inherits3.default)(FullscreenMobileBarV1, _React$Component);

  function FullscreenMobileBarV1(props) {
    (0, _classCallCheck3.default)(this, FullscreenMobileBarV1);

    var _this = (0, _possibleConstructorReturn3.default)(this, (FullscreenMobileBarV1.__proto__ || (0, _getPrototypeOf2.default)(FullscreenMobileBarV1)).call(this, props));

    _this.isNewMobileLayout = _fullscreen.fullscreenVersionManager.useFullscreenNewMobileLayout();
    _this.state = {
      showShare: false
    };
    return _this;
  }

  (0, _createClass3.default)(FullscreenMobileBarV1, [{
    key: 'toggleShare',
    value: function toggleShare(forceVal) {
      this.setState({
        showShare: _lodash2.default.isUndefined(forceVal) ? !this.state.showShare : forceVal
      });
    }
  }, {
    key: 'getLoveButton',
    value: function getLoveButton() {
      var _props = this.props,
          styleParams = _props.styleParams,
          love = _props.love;

      var props = _lodash2.default.pick(this.props, ['itemId', 'id', 'item', 'idx', 'styleParams', 'love', 'hashtag']);
      return styleParams.loveButton ? _react2.default.createElement(_loveButton2.default, (0, _extends3.default)({}, props, { layout: 'fullscreen', device: 'mobile' }, love)) : '';
    }
  }, {
    key: 'getDownloadButton',
    value: function getDownloadButton() {
      var _props2 = this.props,
          current = _props2.current,
          styleParams = _props2.styleParams;

      return _react2.default.createElement(_fullscreenSocialDownload2.default, {
        layout: 'fullscreen',
        device: 'mobile',
        current: current,
        styleParams: styleParams
      });
    }
  }, {
    key: 'getShareContainer',
    value: function getShareContainer(type) {
      var _this2 = this;

      var styleParams = this.props.styleParams;
      var allowSocial = styleParams.allowSocial,
          allowDownload = styleParams.allowDownload;

      var downloadButton = this.getDownloadButton();
      var shareButtonsClassNames = (0, _classnames2.default)('fullscreen-icon', 'fullscreen-social-share-box', {
        vertical: type !== 'top'
      });

      var mobileShareIconsContainer = allowSocial || allowDownload ? _react2.default.createElement(
        'div',
        { className: shareButtonsClassNames },
        allowSocial ? _react2.default.createElement(_fullscreenShareButtons2.default, { item: this.props.current.item }) : false,
        downloadButton
      ) : false;

      var shareButtonClassNames = (0, _classnames2.default)('fullscreen-more', 'progallery-svg-font-icons-more_actions', {
        'show-tooltip': this.props.isPreview
      });

      if (!this.props.styleParams.allowSocial) {
        return false;
      }

      var button = !this.props.isPreview ? _react2.default.createElement('button', {
        className: shareButtonClassNames,
        onClick: function onClick() {
          return _this2.toggleShare();
        }
      }) : _react2.default.createElement('button', {
        className: shareButtonClassNames,
        onMouseOver: function onMouseOver(e) {
          return _itemActions.itemActions.showTooltip(e, 'Gallery_Sharing_Disabled_In_Editor');
        },
        onMouseOut: function onMouseOut() {
          return _itemActions.itemActions.hideTooltip();
        }
      });

      return _react2.default.createElement(
        'div',
        null,
        button,
        mobileShareIconsContainer
      );
    }
  }, {
    key: 'getTopMobileBar',
    value: function getTopMobileBar() {
      var _this3 = this;

      var mobileTopClassNames = (0, _classnames2.default)('fullscreen-mobile-bar', 'fullscreen-mobile-top', {
        'pro-fullscreen-share': this.state.showShare
      });

      return _react2.default.createElement(
        'div',
        { className: mobileTopClassNames },
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement('button', {
            className: 'fullscreen-close progallery-svg-font-icons-back',
            onClick: function onClick() {
              return _this3.props.actions.close(_this3.props.current.idx);
            }
          }),
          this.getShareContainer('top')
        )
      );
    }
  }, {
    key: 'getBottomMobileBar',
    value: function getBottomMobileBar() {
      var _this4 = this;

      return _react2.default.createElement(
        'div',
        { className: 'fullscreen-mobile-bar fullscreen-mobile-bottom' },
        _react2.default.createElement(
          'div',
          null,
          this.getLoveButton(),
          this.props.current.hasInfo ? _react2.default.createElement('i', {
            className: 'fullscreen-info progallery-svg-font-icons-' + (this.props.showInfo ? 'minus' : 'plus'),
            onClick: function onClick() {
              return _this4.props.actions.toggleInfo();
            }
          }) : ''
        )
      );
    }
  }, {
    key: 'getMobileRightBar',
    value: function getMobileRightBar() {
      var _this5 = this;

      return _react2.default.createElement(
        'div',
        {
          className: 'fullscreen-mobile-bar fullscreen-mobile-right ' + (this.state.showShare ? 'pro-fullscreen-share' : '')
        },
        _react2.default.createElement(
          'div',
          null,
          this.props.current.hasInfo ? _react2.default.createElement('i', {
            className: 'fullscreen-info progallery-svg-font-icons-' + (this.props.showInfo ? 'minus' : 'plus'),
            onClick: function onClick() {
              return _this5.props.actions.toggleInfo();
            }
          }) : ''
        )
      );
    }
  }, {
    key: 'getMobileLeftBar',
    value: function getMobileLeftBar() {
      var _this6 = this;

      var mobileLeftClassNames = 'fullscreen-mobile-bar fullscreen-mobile-left';
      var mobileLeft = _react2.default.createElement(
        'div',
        { className: mobileLeftClassNames },
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement('i', {
            className: 'fullscreen-close progallery-svg-font-icons-back',
            onClick: function onClick() {
              return _this6.props.actions.close(_this6.props.current.idx);
            }
          }),
          this.getLoveButton()
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var mobileBars = [];
      if (_utils.utils.isVerticalScreen()) {
        //portrait screen
        mobileBars[0] = this.getTopMobileBar();
        mobileBars[1] = this.getBottomMobileBar();
      } else {
        //landscape screen
        mobileBars[0] = this.getMobileLeftBar();
        mobileBars[1] = this.getMobileRightBar();
      }

      return this.props.isFirst ? mobileBars[0] || false : mobileBars[1] || false;
    }
  }]);
  return FullscreenMobileBarV1;
}(_react2.default.Component);

exports.default = FullscreenMobileBarV1;